import Head from "next/head";

import AdminConsoleFacultyDirectoryPage from "@/admin/AdminConsoleFacultyDirectoryPage";
import withAdminPrivileges from "@/admin/withAdminPrivileges";
import NewselaGlobalLayout from "@/base";
import RootProviders from "@/base/RootProviders";

import { DirectoryPageAuxiliaryDataProvider } from "@/admin/useDirectoryPageAuxiliaryDataContext/useDirectoryPageAuxiliaryDataContext";

const AdminConsoleFacultyDirectoryPageRoute = () => {
  return (
    <>
      <Head>
        <title>Newsela | Faculty Directory</title>
      </Head>
      <NewselaGlobalLayout
        mainContents={
          <DirectoryPageAuxiliaryDataProvider>
            <AdminConsoleFacultyDirectoryPage />
          </DirectoryPageAuxiliaryDataProvider>
        }
      />
    </>
  );
};

export async function getServerSideProps(ctx) {
  const RootProvidersInitialProps = await RootProviders.__getInitialProps({
    ctx,
  });

  return {
    props: {
      [RootProviders.InitialPropsName]: RootProvidersInitialProps,
    },
  };
}
export default withAdminPrivileges(AdminConsoleFacultyDirectoryPageRoute);
